import config from '@/constants/config';

const getEtherscanAddressUrl = (address) => `${config.explorerBaseUrl.address}${address}`;

const toUpperCaseFirstLetter = (str) => str.charAt(0).toUpperCase() + str.substr(1);
const lc = (str) => str.toLowerCase();

export {
    getEtherscanAddressUrl,
    toUpperCaseFirstLetter,
    lc,
};
